<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab v-if="!inEditMode">{{ $t('tabs.documents') }}</v-tab>
					<v-tab v-if="!inEditMode">{{ $t('tabs.navigation') }}</v-tab>
					<v-tab v-if="$myStore.state.user.user_role_id == 1 && !inEditMode">{{
						$t('tabs.contracts')
					}}</v-tab>
					<v-tab v-if="!inEditMode">{{ $t('tabs.activities') }}</v-tab>
					<v-tab v-if="!inEditMode">{{ $t('tabs.appointments') }}</v-tab>
					<v-tab v-if="!inEditMode">{{ $t('tabs.ratings') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text class="pt-2">
								<v-row>
									<v-col>
										<v-card-title class="pa-2">{{ $t('titles.teacherInformations') }}</v-card-title>
									</v-col>
									<v-col class="d-flex justify-end">
										<v-btn
											v-if="inEditMode && $myStore.state.user.user_role_id == 1"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode && $myStore.state.user.user_role_id == 1"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col class="pb-0 pt-0 pr-6">
										<v-row class="d-flex justify-end pt-0">
											<v-rating
												empty-icon="fa-regular fa-star"
												full-icon="fa-solid fa-star"
												half-icon="fa-star-half-stroke"
												readonly
												half-increments
												color="ratingStars"
												length="5"
												size="24"
												:value="finalRating"
											></v-rating>
										</v-row>
										<v-row class="d-flex justify-end pt-0 mr-1">
											<span class="">
												<b>{{ finalRating.toFixed(2) }}</b
												>/5 ({{ $t('labels.numberOfRatings') }} {{ numberOfRatings }})
											</span>
										</v-row>
									</v-col>
								</v-row>
								<v-row wrap>
									<!-- prvi stupac -->
									<v-flex lg6 xs12 sm12 md12 class="pt-0">
										<v-col cols="12" class="pt-0" v-if="$route.params.id != 0">
											<InputField
												:disabled="true"
												v-model="teacher.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12" class="pt-0" v-if="$route.params.id == 0">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.first_name"
												:errorBorder="!teacherValidation.first_name"
												:label="'* ' + $t('fields.firstName')"
											></InputField>
										</v-col>
										<v-col cols="12" v-else>
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.first_name"
												:errorBorder="!teacherValidation.first_name"
												:label="'* ' + $t('fields.firstName')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.last_name"
												:errorBorder="!teacherValidation.last_name"
												:label="'* ' + $t('fields.lastName')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.title"
												:errorBorder="!teacherValidation.title"
												:label="$t('fields.title')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.oib"
												:errorBorder="!teacherValidation.oib"
												:label="'* ' + $t('fields.oib')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.address"
												:errorBorder="!teacherValidation.address"
												:label="'* ' + $t('fields.address')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.postal_code"
												:errorBorder="!teacherValidation.postal_code"
												:label="'* ' + $t('fields.postalCode')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.city"
												:errorBorder="!teacherValidation.city"
												:label="'* ' + $t('fields.city')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="teacher.country"
												:ajax="true"
												:clearable="true"
												:data="'countries'"
												:errorBorder="!teacherValidation.country"
												:label="$t('fields.country')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<v-card flat>
												<v-card-text class="pt-2 pa-0 pl-3">
													<v-card-title class="pa-2 pb-0">{{
														$t('titles.approvals')
													}}</v-card-title>
													<v-row>
														<v-col cols="5">
															<Dropdown2
																:readonly="!inEditMode"
																v-model="course"
																:ajax="true"
																:clearable="true"
																:data="'courses-codes'"
																:errorBorder="!courseValidation"
																:label="'* ' + $t('fields.course')"
																@item-selected="handleCourse"
															></Dropdown2>
														</v-col>
														<v-col cols="5">
															<Dropdown2
																:readonly="!inEditMode"
																v-model="office"
																:ajax="true"
																:clearable="true"
																:data="'offices'"
																:errorBorder="!officeValidation"
																:label="'* ' + $t('fields.office')"
																@item-selected="handleOffice"
															></Dropdown2>
														</v-col>
														<v-col cols="2" class="d-flex align-center">
															<v-tooltip bottom>
																<template v-slot:activator="{ on, attrs }">
																	<v-btn
																		elevation="2"
																		small
																		:disabled="!inEditMode"
																		color="primary"
																		v-bind="attrs"
																		@click="addApproval"
																		v-on="on"
																	>
																		<v-icon small>fa-plus</v-icon>
																	</v-btn>
																</template>
																<span>{{ $t('tooltips.addApproval') }}</span>
															</v-tooltip>
														</v-col>
													</v-row>
													<v-container
														v-if="teacher.approvals.length > 0"
														class="overflow-container pa-0"
													>
														<v-row
															v-for="(item, key) in teacher.approvals"
															:key="key"
															no-gutters
														>
															<v-col cols="10" class="pb-1 pt-0">
																<v-card
																	:key="item.id"
																	outlined
																	:class="{ 'item-bg-color': $vuetify.theme.dark }"
																>
																	<v-row no-gutters>
																		<v-col
																			cols="6"
																			class="pa-1 pl-2 d-flex align-center"
																		>
																			<div
																				:class="[
																					'text-subtitle-1',
																					'pa-2',
																					'pl-0',
																				]"
																			>
																				{{ item.courseCode }}
																			</div>
																		</v-col>
																		<v-col
																			cols="6"
																			class="pa-1 pl-2 d-flex align-center"
																		>
																			<div
																				:class="[
																					'text-subtitle-1',
																					'pa-2',
																					'pl-1',
																				]"
																			>
																				{{ item.officeName }}
																			</div>
																		</v-col>
																	</v-row>
																</v-card>
															</v-col>
															<v-col
																cols="1"
																v-if="inEditMode && item.hasOwnProperty('id')"
																class="pb-0 d-flex align-center"
															>
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			icon
																			large
																			v-bind="attrs"
																			@click="deleteApproval(item.id)"
																			v-on="on"
																		>
																			<v-icon small>fa-trash</v-icon>
																		</v-btn>
																	</template>
																	<span>{{ $t('tooltips.delete') }}</span>
																</v-tooltip>
															</v-col>
															<v-col
																cols="1"
																v-if="inEditMode && !item.hasOwnProperty('id')"
																class="pb-0 d-flex align-center"
															>
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			icon
																			large
																			v-bind="attrs"
																			@click="
																				deleteClick(
																					item.courseCode,
																					item.officeName
																				)
																			"
																			v-on="on"
																		>
																			<v-icon small>fa-trash</v-icon>
																		</v-btn>
																	</template>
																	<span>{{ $t('tooltips.delete') }}</span>
																</v-tooltip>
															</v-col>
														</v-row>
													</v-container>
												</v-card-text>
											</v-card>
										</v-col>
									</v-flex>
									<!-- drugi stupac -->
									<v-flex lg6 xs12 sm12 md12 class="pt-0">
										<v-col cols="12" class="pt-0">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.phone"
												:errorBorder="!teacherValidation.phone"
												:label="'* ' + $t('fields.phone')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.email"
												:errorBorder="!teacherValidation.email"
												:label="'* ' + $t('fields.email')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.bank"
												:errorBorder="!teacherValidation.bank"
												:label="'* ' + $t('fields.bank')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="teacher.iban"
												:errorBorder="!teacherValidation.iban"
												:label="'* ' + $t('fields.iban')"
											></InputField>
										</v-col>
										<div :class="['text-subtitle-1', 'pa-2', 'pb-0', 'mt-9']">
											{{ $t('titles.hourlyRates') }}
										</div>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="teacher.t1"
												:clearable="true"
												:precision="2"
												:errorBorder="!teacherValidation.t1"
												:label="$t('fields.t1')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="teacher.t2"
												:clearable="true"
												:precision="2"
												:errorBorder="!teacherValidation.t2"
												:label="$t('fields.t2')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="teacher.t3"
												:clearable="true"
												:precision="2"
												:errorBorder="!teacherValidation.t3"
												:label="$t('fields.t3')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="teacher.t4"
												:clearable="true"
												:precision="2"
												:errorBorder="!teacherValidation.t4"
												:label="$t('fields.t4')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												v-model="teacher.remark"
												:errorBorder="!teacherValidation.remark"
												:label="$t('fields.remark')"
												rows="3"
											></TextArea>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="teacher.active"
												:label="$t('fields.active')"
											></CheckBox>
										</v-col>
									</v-flex>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item v-if="!inEditMode"> <TeacherDocuments></TeacherDocuments></v-tab-item>
					<v-tab-item v-if="!inEditMode"> <TeacherNavigations></TeacherNavigations></v-tab-item>
					<v-tab-item v-if="$myStore.state.user.user_role_id == 1 && !inEditMode"
						><TeacherContracts :teacherId="teacher.id"></TeacherContracts
					></v-tab-item>
					<v-tab-item v-if="!inEditMode"
						><TeacherActivities :teacherId="teacher.id"></TeacherActivities
					></v-tab-item>
					<v-tab-item v-if="!inEditMode"
						><TeacherAppointments :teacherId="teacher.id"></TeacherAppointments
					></v-tab-item>
					<v-tab-item>
						<TeacherRatings :teacherId="teacher.id"></TeacherRatings>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Dropdown from '../../trinkets/Dropdown';
import Dropdown2 from '../../trinkets/Dropdown2';
import NumberField from '../../trinkets/NumberField';
import TextArea from '../../trinkets/TextArea';
import Teacher from '../../../models/Teacher';
import TeacherActivities from './TeacherActivities';
import TeacherAppointments from './TeacherAppointments';
import TeacherContracts from './TeacherContracts';
import TeacherRatings from './TeacherRatings';
import TeacherDocuments from './TeacherDocuments';
import TeacherNavigations from './TeacherNavigations';

export default {
	name: 'Teacher',
	components: {
		CheckBox,
		InputField,
		Dropdown,
		Dropdown2,
		NumberField,
		TextArea,
		TeacherActivities,
		TeacherAppointments,
		TeacherContracts,
		TeacherRatings,
		TeacherDocuments,
		TeacherNavigations,
	},
	data: function () {
		return {
			teacher: new Teacher({ id: this.$route.params.id }),
			teacherValidation: new Teacher({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'teacher',
			lockTimer: null,
			finalRating: 0,
			numberOfRatings: 0,
			office: null,
			course: null,
			officeDisplay: null,
			courseDisplay: null,
			officeValidation: true,
			courseValidation: true,
		};
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.teacher.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.teacher.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		addApproval() {
			let success = true;

			if (this.course == null) {
				success = false;
				this.courseValidation = false;
			} else {
				this.courseValidation = true;
			}

			if (this.office == null) {
				success = false;
				this.officeValidation = false;
			} else {
				this.officeValidation = true;
			}

			if (success) {
				if (this.approvalExists(this.courseDisplay, this.officeDisplay)) {
					this.$alert(this.$t('alerts.approvalExists'));
				} else {
					if (this.$route.params.id != 0) {
						this.teacher.newApprovals.push({
							teacher_id: this.$route.params.id,
							course_id: this.course,
							office_id: this.office,
							courseCode: this.courseDisplay,
							officeName: this.officeDisplay,
						});
					}
					this.teacher.approvals.push({
						teacher_id: this.$route.params.id,
						course_id: this.course,
						office_id: this.office,
						courseCode: this.courseDisplay,
						officeName: this.officeDisplay,
					});
					this.courseDisplay = null;
					this.officeDisplay = null;
					this.course = null;
					this.office = null;
				}
			}
		},
		handleCourse(item) {
			this.courseDisplay = item.name;
		},
		handleOffice(item) {
			this.officeDisplay = item.name;
		},
		approvalExists(courseCode, officeName) {
			return this.teacher.approvals.some(
				(item) => item.courseCode === courseCode && item.officeName === officeName
			);
		},
		deleteClick(courseCode, officeName) {
			this.teacher.approvals = this.teacher.approvals.filter(
				(item) => item.courseCode !== courseCode || item.officeName !== officeName
			);
			this.teacher.newApprovals = this.teacher.newApprovals.filter(
				(item) => item.courseCode !== courseCode || item.officeName !== officeName
			);
		},
		deleteApproval(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					this.teacher.approvals = this.teacher.approvals.filter((item) => item.id !== id);
					vm.$APICall(
						'delete',
						'teacher-approvals/' + id + '/delete',
						{ teacher_id: this.$route.params.id, id: id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (this.teacher.first_name == null || this.teacher.first_name == '') {
				success = false;
				this.teacherValidation.first_name = false;
			} else {
				if (this.teacher.first_name.length > 50) {
					this.teacherValidation.first_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.firstName'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.teacherValidation.first_name = true;
				}
			}

			if (this.teacher.last_name == null || this.teacher.last_name == '') {
				success = false;
				this.teacherValidation.last_name = false;
			} else {
				if (this.teacher.last_name.length > 50) {
					this.teacherValidation.last_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.lastName'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.teacherValidation.last_name = true;
				}
			}

			if (this.teacher.title != null && this.teacher.title > 150) {
				this.teacherValidation.title = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.title'))
						.replace('%length%', '150') + '<br />';
			} else {
				this.teacherValidation.title = true;
			}

			if (this.teacher.oib == null || this.teacher.oib == '') {
				success = false;
				this.teacherValidation.oib = false;
			} else {
				if (this.teacher.oib.length > 20) {
					this.teacherValidation.oib = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.oib'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.teacherValidation.oib = true;
				}
			}

			if (this.teacher.address == null || this.teacher.address == '') {
				success = false;
				this.teacherValidation.address = false;
			} else {
				if (this.teacher.address.length > 150) {
					this.teacherValidation.address = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.address'))
							.replace('%length%', '150') + '<br />';
				} else {
					this.teacherValidation.address = true;
				}
			}

			if (this.teacher.postal_code == null || this.teacher.postal_code == '') {
				success = false;
				this.teacherValidation.postal_code = false;
			} else {
				if (this.teacher.postal_code.length > 20) {
					this.teacherValidation.postal_code = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.postalCode'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.teacherValidation.postal_code = true;
				}
			}

			if (this.teacher.city == null || this.teacher.city == '') {
				success = false;
				this.teacherValidation.city = false;
			} else {
				if (this.teacher.city.length > 50) {
					this.teacherValidation.city = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.city'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.teacherValidation.city = true;
				}
			}

			if (this.teacher.phone == null || this.teacher.phone == '') {
				success = false;
				this.teacherValidation.phone = false;
			} else {
				if (this.teacher.phone.length > 50) {
					this.teacherValidation.phone = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.phone'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.teacherValidation.phone = true;
				}
			}

			if (this.teacher.email == null || this.teacher.email == '') {
				success = false;
				this.teacherValidation.email = false;
			} else {
				if (!this.$checkEmail(this.teacher.email)) {
					this.teacherValidation.email = false;
					errorMessages += this.$t('alerts.formatError').split('%value%').join('E-mail') + '<br />';
				} else {
					this.teacherValidation.email = true;
				}
			}

			if (this.teacher.bank == null || this.teacher.bank == '') {
				success = false;
				this.teacherValidation.bank = false;
			} else {
				if (this.teacher.bank.length > 150) {
					this.teacherValidation.bank = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.bank'))
							.replace('%length%', '150') + '<br />';
				} else {
					this.teacherValidation.bank = true;
				}
			}

			if (this.teacher.iban == null || this.teacher.iban == '') {
				success = false;
				this.teacherValidation.iban = false;
			} else {
				if (this.teacher.iban != '' && !this.$checkIBAN(this.teacher.iban)) {
					this.teacherValidation.iban = false;
					errorMessages += this.$t('alerts.formatError').split('%value%').join('IBAN') + '<br />';
				} else {
					this.teacherValidation.iban = true;
					this.teacher.iban = this.teacher.iban != '' ? this.teacher.iban.toUpperCase() : '';
				}
			}

			if (this.teacher.t1 != null && (this.teacher.t1 < 0.01 || this.teacher.t1 > 1000)) {
				this.teacherValidation.t1 = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.t1'))
						.replace('%min%', '0.01')
						.replace('%max%', '1000') + '<br />';
			} else {
				this.teacherValidation.t1 = true;
			}

			if (this.teacher.t2 != null && (this.teacher.t2 < 0.01 || this.teacher.t2 > 1000)) {
				this.teacherValidation.t2 = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.t2'))
						.replace('%min%', '0.01')
						.replace('%max%', '1000') + '<br />';
			} else {
				this.teacherValidation.t2 = true;
			}

			if (this.teacher.t3 != null && (this.teacher.t3 < 0.01 || this.teacher.t3 > 1000)) {
				this.teacherValidation.t3 = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.t3'))
						.replace('%min%', '0.01')
						.replace('%max%', '1000') + '<br />';
			} else {
				this.teacherValidation.t3 = true;
			}

			if (this.teacher.t4 != null && (this.teacher.t4 < 0.01 || this.teacher.t4 > 1000)) {
				this.teacherValidation.t4 = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.t4'))
						.replace('%min%', '0.01')
						.replace('%max%', '1000') + '<br />';
			} else {
				this.teacherValidation.t4 = true;
			}

			if (this.teacher.remark != null && this.teacher.remark.length > 2000) {
				this.teacherValidation.remark = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.remark'))
						.replace('%length%', '2000') + '<br />';
			} else {
				this.teacherValidation.remark = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.teacher.id != 0) {
					action = 'put';
					addition = '/' + vm.teacher.id;
				}
				this.$APICall(action, 'teachers' + addition, this.teacher, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.teacher.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.teacher.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.teacher.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		let vm = this;
		if (this.teacher.id != 0) {
			this.$APICall('get', 'teachers/' + this.teacher.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.teacher = usableData.item;
					vm.teacher.newApprovals = [];
					vm.finalRating = usableData.finalRating;
					vm.numberOfRatings = usableData.numberOfRatings;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.teachers'),
							href: '/#/teachers',
							disabled: false,
						},
						{
							text: vm.teacher.first_name + ' ' + vm.teacher.last_name + ' (' + vm.teacher.id + ')',
							href: '/#/teachers/' + vm.teacher.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.teachers'),
					href: '/#/teachers',
					disabled: false,
				},
				{
					text: this.$t('modules.newTeacher'),
					href: '/#/teachers/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped>
.overflow-container {
	max-height: 250px;
	overflow-y: auto;
}

.item-bg-color {
	background: #444;
}
</style>
